import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'

function InputModal({isOpen, closeModal, modalInputs, title, savefn, overflowVisible=false, maxw="max-w-sm", outerTouchClose=true, inputcls="mt-3 mb-5 px-4"}) {
  return (
    <Transition className="font-GoogleSans tracking-wider" appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={outerTouchClose?closeModal:()=>{}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center text-center p-3 sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`w-full ${maxw} transform select-none ${!overflowVisible && 'overflow-hidden'} ${overflowVisible && 'overflow-visible'} rounded-lg bg-white text-left align-middle shadow-xl py-0 transition-all`}>
                  <Dialog.Title
                    as="h3"
                    className="font-medium leading-6 px-4 pt-4 pb-4 bg-gray-100 rounded-t-lg font-GoogleSans border-b"
                  >
                    {title}
                  </Dialog.Title>
                  <div className={`${inputcls}`}>
                    {modalInputs}
                  </div>

                  <div className="flex justify-end font-Inter gap-2 px-3.5 pt-3 pb-3 border-t">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-lg border border-transparent bg-blue-100 px-5 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
                      onClick={savefn}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-lg border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
  )
}

export default InputModal